import VLoading from '@/components/vkyc/v-loading';
import VScreen from 'components/vkyc/v-screen';
import vHistory, { VPathKey } from 'lib/history';
import webSocket from 'lib/socket';
import React, { useEffect, useState } from 'react';
import PageRoutes from './routes';

const Main = () => {
  const [authenticating, setAuthenticating] = useState(true);

  useEffect(() => {
    if (
      vHistory.currentPathIs(VPathKey.WAITING_ROOM) ||
      vHistory.currentPathIs(VPathKey.CHATTING_ROOM)
    ) {
      webSocket.initAndOpen();
    }

    // different tenant init different info
    setAuthenticating(false);
  }, []);

  return <VScreen>{authenticating ? <VLoading show /> : <PageRoutes />}</VScreen>;
};

export default Main;
